<ng-container *transloco="let t">

  <ng-container *ngIf="worker">

        <ng-container *ngIf="!worker.app_settings || worker.app_settings.device=='Unknown'">
        <p>{{ t("We don't have any app settings for this worker.") }}</p>
      </ng-container>
      <ng-container *ngIf="worker.app_settings && worker.app_settings.device!='Unknown'">
        <p>
          {{ t('Here are the current app settings for') }} {{ worker.name }}, {{ t('last updated at') }} {{ worker.app_settings.last_update }}.
        </p>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">{{ t('Setting Name') }}</th>
              <th scope="col">{{ t('Setting Value') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of worker.app_settings | keyvalue">
              <tr *ngIf="item.value !== null && item.value !== undefined && item.value !== '' && item.value !== 0">
                <th>{{ item.key | fieldtitle }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>

</ng-container>

</ng-container>
